/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: gatewaysActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Calls Routing module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { GATEWAYS_ENDPOINT, requestGatewaysApi } from './api';

/**
 * Build the URL used to open the Gateway form in duplicate mode.
 * Pattern: /pbx/calls-routing/gateways/new?duplicate={id}
 */
export const getGatewayDuplicateUrl = (id: string | number): string =>
  `/pbx/calls-routing/gateways/new?duplicate=${id}`;

/**
 * Navigate to the Gateway form in duplicate mode.
 */
export const navigateToGatewayDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getGatewayDuplicateUrl(id));
};

/**
 * Delete a gateway by identifier (id or uuid).
 * The backend accepts both numeric IDs and UUIDs in the path.
 */
export const deleteGatewayById = async (id: string | number): Promise<void> => {
  await requestGatewaysApi<null>(
    `${GATEWAYS_ENDPOINT}/${id}`,
    'Failed to delete gateway',
    { method: 'DELETE' },
  );
};



